import { colors } from 'theme'

export const defaultThemeStyles = {
    on: colors.blueLight,
    off: colors.cloud,
    onHandler: colors.blue,
    offHandler: colors.darkCloud,
}
